// SPDX-License-Identifier: GPL-3.0-or-later

import { CV_JSON_SCHEMA } from '../schemas';

export interface CvPromptInputs {
  profileText: string;
  jobTitle: string;
  companyName: string;
  jobUrl: string;
  applyType: string;
  jobDescription: string;
}

export const cvSystemPrompt = `You are a senior career coach helping the user produce a tailored CV for a specific role.

You output ONLY valid JSON matching exactly this TypeScript shape:

${CV_JSON_SCHEMA}

Rules:
- No markdown, no code fences, no commentary — only the JSON object.
- Tune the summary and bullet points to the job description, but never invent companies, technologies, dates, or quantified results that aren't supported by the profile. If a claim isn't in the profile, leave it out.
- Bullets are concrete and outcome-oriented; prefer "Built X to do Y, reducing Z by N%" over "Responsible for X".
- Keep summary to 2–3 sentences.
- Skills entries should be themed (e.g. "Languages", "Cloud", "Tools") not a flat dump.
- Use plain text for all fields. Do NOT include LaTeX or HTML; the rendering layer escapes everything.`;

export function cvUserPrompt(inputs: CvPromptInputs): string {
  return `<profile>
${inputs.profileText.trim() || '(profile is empty)'}
</profile>

<job>
Title: ${inputs.jobTitle}
Company: ${inputs.companyName}
Apply type: ${inputs.applyType}
URL: ${inputs.jobUrl}

${inputs.jobDescription.trim() || '(no description recorded)'}
</job>

Produce the tailored CV as JSON matching the schema. Output only the JSON.`;
}
